module.exports = __webpack_public_path__ + "static/media/1.93e6602c.png";